<template>
  <main class="integration-list">
    <modal-dialog
      title=""
      v-model="isShownModal"
      with-cross
    >
      <div class="integration-list__modal">
        <span>
          <b>Модуль {{ selectedIntegrationTitle }} платный.</b>
        </span>
        <span>
          {{ integrationText }}<br>
          Татьяна
          <a v-bind:href="$options.supportPhoneHref">
            {{ $options.supportPhoneTitle }}
          </a>
        </span>
      </div>
    </modal-dialog>
    <div class="integration-list__container">
      <h1 class="integration-list__title">Интеграции</h1>
      <div class="integration-list__items">
        <integration-item
          class="integration-list__item"
          v-for="{ integration, routeName } in integrations"
          v-bind:key="integration.id"
          v-bind:route-name="routeName"
          v-bind:tags="integration.tags"
          v-on:click="onIntegrationClick(integration)"
        >
          <span class="integration-list__item__caption">{{integration.title}}</span>
          <span
            v-if="integration.description"
            class="integration-list__item__description"
          >
            {{ integration.description }}
          </span>
        </integration-item>
      </div>
    </div>
  </main>
</template>

<script>
import ModalDialog from '@/components/ModalDialog.vue';
import aboutMixin from '@/mixins/aboutMixin';

/**
 * @description Элемент списка.
 * @type {object}
 */
const IntegrationItem = {
  props: {
    routeName: { default: () => '', type: String },
    tags: { required: true, type: Array },
  },
  name: 'IntegrationItem',
  render(createElement) {
    if (this.tags.includes('settings') && !this.tags.includes('disabled')) {
      return createElement(
        'router-link',
        { props: { to: { name: this.routeName } } },
        this.$slots.default,
      );
    }
    return createElement(
      'button',
      { attrs: { type: 'button' }, on: { click: () => this.$emit('click') } },
      this.$slots.default,
    );
  },
};

/**
 * @description Название маршрута по секции.
 * @type {object}
 */
const ROUTE_NAME_BY_SECTION = {
  'aggregator-integrations': 'ClinicPanelIntegration32top',
  'uis-integration-settings': 'ClinicPanelIntegrationUis',
  'mango-office-integration-settings': 'ClinicPanelIntegrationMangoOffice',
  'prodoctorov-integrations': 'ClinicPanelIntegrationProdoctorov',
};

/**
 * @description Страница списка интеграций.
 * @type {object}
 */
export default {
  components: {
    IntegrationItem,
    ModalDialog,
  },
  computed: {
    integrations() {
      return this.integrationList.map((integration) => ({
        integration,
        routeName: ROUTE_NAME_BY_SECTION[integration.id] || '',
      }));
    },
    integrationText() {
      return this.selectedIntegrationDisabled
        ? 'Чтобы подключить модуль, свяжитесь с вашим менеджером:'
        : 'Возникли вопросы по использованию сервиса? Обратитесь по номеру:';
    },
  },
  created() {
    this.fetchIntegrations();
  },
  data() {
    return {
      integrationList: [],
      isShownModal: false,
      isShownModalHelp: false,
      selectedIntegrationDisabled: false,
      selectedIntegrationTitle: '',
    };
  },
  methods: {
    /**
     * @description Получить интеграции.
     * @returns {void}
     */
    fetchIntegrations() {
      const onResponse = (integrations) => {
        this.integrationList = integrations;
      };
      this
        .$suggestionGateway
        .viewAllIntegrations()
        .then((result) => result.forEach(onResponse));
    },
    /**
     * @description Обработать клик по интеграции.
     * @param {{title:string}} integration
     * @returns {void}
     */
    onIntegrationClick({ title, tags }) {
      this.selectedIntegrationDisabled = !!tags.includes('disabled');
      this.isShownModal = true;
      this.selectedIntegrationTitle = title;
    },
  },
  mixins: [aboutMixin],
  name: 'ClinicPanelIntegrationList',
};
</script>

<style scoped lang="scss">
@use "@/scss/buttons";

.integration-list {
  width: 100%;
  height: 100vh;
  overflow-y: scroll;
  &__container {
    padding: 38px 20px 48px 23px;
    width: 100%;
    max-width: 1187px;
  }
  &__title {
    color: #000000;
    margin: 0;
  }
  &__modal {
    font-size: 1rem;
    color: var(--reading-color);
  }
  &__items {
    margin-top: 20px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 12px;
  }
  &__item {
    text-align: center;
    padding: 0 5px;
    @include buttons.btn-transparent(100%, 100px, 18px);
    text-decoration: none;
    display: flex;
    flex-direction: column;
    gap: 10px;
    &__caption {
      font-weight: 700;
    }
    &__description {
      font-size: 1rem;
      color: #707683;
    }
  }
  &__modal {
    display: flex;
    flex-direction: column;
    gap: 10px;
    a:hover {
      text-decoration: none;
    }
  }
}
@media screen and (max-width: 480px) {
  .integration-list {
    &__items {
      grid-template-columns: 1fr;
    }
  }
}
</style>
